<script lang="ts">
  import moment from "moment";
  import T from "../texts";
  import type { TicketEvent } from "../../../types/ticket";
  import { getThumbnailURL } from "../../../lib";

  export let s;
  export let ticketEvent: TicketEvent;
  export let language;
</script>

<div class={s.agentAnnouncementWrapper}>
  <div class={s.agentAnnouncementSubText}>
    {moment(ticketEvent.created_at).format("dddd h:mma")}
  </div>
  <img
    class={s.agentAnnouncementThumbnail}
    src={getThumbnailURL(ticketEvent.actor_id)}
    alt="Thumbnail"
  />
  <div class={s.agentAnnouncement}>
    {T(language, "You're chatting with {0}", [ticketEvent.actor_full_name])}
  </div>
</div>
